var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMyStationWhite = function SvgMyStationWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 13 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.12 6.56A6.06 6.06 0 1 0 .838 9.633L6.06 19l5.223-9.367c.531-.9.837-1.95.837-3.073M6.06 2.476a4.09 4.09 0 0 1 4.084 4.084 4.09 4.09 0 0 1-4.084 4.084A4.09 4.09 0 0 1 1.976 6.56 4.09 4.09 0 0 1 6.06 2.476"
  })));
};
export default SvgMyStationWhite;